import React from 'react';
import { Typography as PdcTypography } from '@mzc-pdc/ui';
import { TypographyProps } from './infrastructures/TypographyProps';

export const TypographySubtitle1 = (props: TypographyProps) => (
  <PdcTypography
    variant={props.bold ? 'subtitle1_500' : 'subtitle1'}
    align={props.centered ? 'center' : undefined}
  >
    {props.children}
  </PdcTypography>
);
